import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import CommonComponentForQuestionsAndOption from '../Common/FeedbackGridRow';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/styles.css';
import '../../assets/css/login.css';
var Modal = require('react-bootstrap-modal');
const axios = require('axios').default;
var config = require('../../config/config.json');

var slectedTeacherID = "";
var slectedSubjectID = "";
var MaintainFinalSubmitBit = "";
var allCourseTransactionStudentAnswersArray = [];

var AllTheoryFeedbackSubmittedBit = true;
var AllPracticalFeedbackSubmittedBit = true;

let TheroyPacticalActiveBit = true;

let CompalsoryCount = 0;
let SubmittedCompalsoryCount = 0;

export default function CourseTransactionFeedback(props) {
  document.title = props.title;
  const navigate = useNavigate();

  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));
  var selectedStudentClassSemester = localStorage.getItem('selectedStudentClassSemester');
  const [modelPopupStatus, setModelPopupStatus] = useState(false);

  const [allCompalsoryDoneBit, setallCompalsoryDoneBit] = useState(false);

  const [componentLodignState, setComponentLodignState] = useState(false);

  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [allCourseTransactionQuestionsArray, setCourseTransactionQuestionsArray] = useState([]);
  // const [allCourseTransactionStudentAnswersArray, setCourseTransactionStudentAnswersArray] = useState([]);
  const [allPageLoadArrayForSubjectAndTeacherArray, setPageLoadArrayForSubjectAndTeacher] = useState({});

  const [allSubjectAndTeacherDetailsArray, setSubjectAndTeacherDetailsArray] = useState({});

  const [allTeacherNameWithIDArray, setTeacherNameWithIDArray] = useState({});

  // const [slectedTeacherID, setSlectedTeacherID] = useState("");
  // const [slectedSubjectID, setSlectedSubjectID] = useState("");

  const [callOnes, setcallOnes] = useState("0");

  var activeSubject = 0;
  var activeTeacher = 0;
  //const [activeTeacher, setactiveTeacher] = useState("0");

  useEffect(() => {
    getAllTeacharAndSubjectData();
  }, []);

  function getAllTeacharAndSubjectData() {
    setCourseTransactionQuestionsArray([]);
    setTeacherNameWithIDArray({});
    setSubjectAndTeacherDetailsArray({})
    setcallOnes(0);
    setComponentLodignState(true);
    AllTheoryFeedbackSubmittedBit = true;
    AllPracticalFeedbackSubmittedBit = true;
    TheroyPacticalActiveBit = true;
    CompalsoryCount = 0;
    SubmittedCompalsoryCount = 0;

    setTimeout(() => {
      axios.post(config.API_URL + 'fetchSubjectandTeacherdetails', {
        userId: userLoginDetails.mstr_auto_id,
        currentAcademicYear: userLoginDetails.mstr_student_teacher_academic_year,
        classSemester: selectedStudentClassSemester,
        courseId: userLoginDetails.mstr_student_course,
        sectionName: userLoginDetails.mstr_section_name
      }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      }).then(function (response) {
        if (response.data.status.status == 1) {
          if (response.data.data != null && response.data.data != "") {
            console.log("setSubjectAndTeacherDetailsArray ---> ", response.data.data);
            if (Object.keys(response.data.data['Theory']).length === 0) {
              toast.error("No data available for this semester & academic year");
              setTimeout(() => {
                navigate('/StudentDashboard');
              }, 2500);
            } else {
              Object.keys(response.data.data['Theory']).map(function (key, index) {
                console.log("setSubjectAndTeacherDetailsArray key key ---> ", key);
                if (key.split('~')[2] == "Compulsory") {
                  CompalsoryCount += 1;
                }

                if (Object.keys(response.data.data['Theory'][key]).every((k) => response.data.data['Theory'][key][k] == 1) == true) {
                  if (key.split('~')[2] == "Compulsory") {
                    SubmittedCompalsoryCount += 1;
                  }
                } else {
                  AllTheoryFeedbackSubmittedBit = false;
                }
              })

              Object.keys(response.data.data['Practical']).map(function (key, index) {
                if (key.split('~')[2] == "Compulsory") {
                  CompalsoryCount += 1;
                }
                //  console.log("setSubjectAndTeacherDetailsArray key key ---> ", key);
                if (Object.keys(response.data.data['Practical'][key]).every((k) => response.data.data['Practical'][key][k] == 1) == true) {
                  if (key.split('~')[2] == "Compulsory") {
                    SubmittedCompalsoryCount += 1;
                  }
                } else {
                  AllPracticalFeedbackSubmittedBit = false;
                }
              })

              allCourseTransactionStudentAnswersArray = [];
              slectedTeacherID = "";
              slectedSubjectID = "";
              activeSubject = 0;
              activeTeacher = 0;
              setPageLoadArrayForSubjectAndTeacher(response.data.data);
              if (AllTheoryFeedbackSubmittedBit == false) {
                setSubjectAndTeacherDetailsArray(response.data.data["Theory"]);
                TheroyPacticalActiveBit = true;
              } else {
                setSubjectAndTeacherDetailsArray(response.data.data["Practical"]);
                TheroyPacticalActiveBit = false;
              }

              getAllCourseTransactionQuestions();

              setTimeout(() => {
                if (AllTheoryFeedbackSubmittedBit == true && AllPracticalFeedbackSubmittedBit == true) {
                  updateFinalCourseTransactionBit();
                }
                if (CompalsoryCount === SubmittedCompalsoryCount) {
                  setallCompalsoryDoneBit(true);//allCompalsoryDoneBit = true;
                }
              }, 1500);
            }
          } else {
            setPageLoadArrayForSubjectAndTeacher([]);
          }
          setComponentLodignState(false);
        }
      }).catch(function (error) {
        toast.error(error);
        setComponentLodignState(false);
      });
    }, 500);
  }

  function updateFinalCourseTransactionBit() {
    axios.post(config.API_URL + 'updateFinalFeedback', {
      ragisterUserId: userLoginDetails.mstr_auto_id,
      submittedFeedbackType: "Course Transaction",
      userRole: userLoginDetails.role_master_auto_id,
      currentAcademicYear: userLoginDetails.mstr_student_teacher_academic_year,
      classSemester: selectedStudentClassSemester,
      finalSubmitBit: 1,
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        toast.success(response.data.status.message);
        setModelPopupStatus(true);
        // navigate('/StudentDashboard');
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }


  function getAllCourseTransactionQuestions() {
    axios.post(config.API_URL + 'getCourseTransactionQuestion', {
      userId: userLoginDetails.mstr_auto_id
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setCourseTransactionQuestionsArray(response.data.data);
        } else {
          setCourseTransactionQuestionsArray([]);
        }
      }
    }).catch(function (error) {
      toast(error);
    });
  }

  const onItemClick = useCallback(event => {
    let Obj = {
      question_id: event.target.getAttribute('questionid'),
      subject_id: slectedSubjectID,
      teacher_id: slectedTeacherID,
      answer: event.target.getAttribute('questionanswer'),
      description: ""
    }
    if (allCourseTransactionStudentAnswersArray.length == 0) {
      allCourseTransactionStudentAnswersArray.push(Obj)
      // setCourseTransactionStudentAnswersArray(allCourseTransactionStudentAnswersArray);
    } else {
      let checkNewPushBit = true;
      let obj = allCourseTransactionStudentAnswersArray.find((o, i) => {
        if (o.question_id === event.target.getAttribute('questionid')) {
          allCourseTransactionStudentAnswersArray[i] = Obj;
          checkNewPushBit = false;
        }
      });
      if (checkNewPushBit) {
        allCourseTransactionStudentAnswersArray.push(Obj)
      }
      // setCourseTransactionStudentAnswersArray(allCourseTransactionStudentAnswersArray);
    }
    var element = document.getElementById("studentInfra" + event.target.getAttribute('questionid'));
    element.classList.remove("error");
    // var target = event.target;
    // var parent = target.parentElement.parentElement;//parent of "target"
  }, [allCourseTransactionQuestionsArray]);


  function onCourseTransactionClick() {
    if (allCourseTransactionStudentAnswersArray.length == allCourseTransactionQuestionsArray.length) {
      axios.post(config.API_URL + 'submitCoursetransactionFeedback', {
        ragisterUserId: userLoginDetails.mstr_auto_id,
        submittedFeedbackType: "Course Transaction",
        userRole: userLoginDetails.role_master_auto_id,
        currentAcademicYear: userLoginDetails.mstr_student_teacher_academic_year,
        classSemester: selectedStudentClassSemester,
        finalSubmitBit: MaintainFinalSubmitBit,
        answersArray: allCourseTransactionStudentAnswersArray
      }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      }).then(function (response) {
        if (response.data.status.status == 1) {
          toast.success(response.data.status.message);
          getAllTeacharAndSubjectData();
        }
      }).catch(function (error) {
        toast.error(error);
      });
    } else {
      allCourseTransactionQuestionsArray.map((questions, index) => {
        let checkValidation = allCourseTransactionStudentAnswersArray.find(o => o.question_id === questions.mafq_auto_id);
        if (!checkValidation) {
          var element = document.getElementById("studentInfra" + questions.mafq_auto_id);
          element.classList.add("error");
        }
      });
      toast.error("All questions are compulsory.");
    }
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/Student');
  }

  let saveAndClose = () => {
    setModelPopupStatus(false);
    navigate('/StudentDashboard');
  }

  function subjectProgramChange(getSubjectNameWithID, checkStatus, event) {
    let objForTeacher = {};
    if (callOnes == 0 && checkStatus == "No") {
      setTeacherNameWithIDArray({});
      Object.keys(allSubjectAndTeacherDetailsArray[getSubjectNameWithID]).map(function (key, index) {
        objForTeacher[key] = allSubjectAndTeacherDetailsArray[getSubjectNameWithID][key];
      });
      setTeacherNameWithIDArray(objForTeacher);
      setcallOnes(1);
      slectedSubjectID = event;
    }
    // if (checkStatus == "No") {
    //   slectedSubjectID = event;
    // }

    if (callOnes == 1 && checkStatus == "Yes") {
      activeTeacher = 0;
      var target = event.currentTarget;
      var parent = target.parentElement;//parent of "target"
      var children = [].slice.call(parent.getElementsByTagName('*'), 0);

      children.map(function (child) {
        if (child.classList[0] == "active") {
          child.classList.remove('active')
        }
      });
      target.classList.add('active');

      setTeacherNameWithIDArray({});
      Object.keys(allSubjectAndTeacherDetailsArray[getSubjectNameWithID]).map(function (key, index) {
        objForTeacher[key] = allSubjectAndTeacherDetailsArray[getSubjectNameWithID][key];
      });
      setTimeout(() => {
        setTeacherNameWithIDArray(objForTeacher);
      }, 500);
      slectedSubjectID = event.target.getAttribute('customesubjectid');
    }
  }

  function changePaperType(slectedType, event) {
    var target = event.currentTarget;
    var parent = target.parentElement;//parent of "target"
    var children = [].slice.call(parent.getElementsByTagName('*'), 0);
    setcallOnes(0);
    children.map(function (child) {
      if (child.classList[0] == "active") {
        child.classList.remove('active')
      }
    });
    target.classList.add('active');

    if (slectedType == "Theory") {
      console.log(allPageLoadArrayForSubjectAndTeacherArray["Theory"]);
      setSubjectAndTeacherDetailsArray(allPageLoadArrayForSubjectAndTeacherArray["Theory"]);
    } else {
      setSubjectAndTeacherDetailsArray(allPageLoadArrayForSubjectAndTeacherArray["Practical"]);
    }
  }

  function clickBackToMain() {
    navigate('/StudentDashboard');
  }

  function teacherProgramChange(selectedTeacherID, checkStatus, event) {
    if (callOnes == 0 && checkStatus == "No") {
      slectedTeacherID = event;
    }
    if (checkStatus == "No") {
      slectedTeacherID = event;
    }
    if (callOnes == 1 && checkStatus == "Yes") {
      var target = event.currentTarget;
      var parent = target.parentElement;//parent of "target"
      slectedTeacherID = event.target.getAttribute('custometeacherid');

      var children = [].slice.call(parent.getElementsByTagName('*'), 0);
      children.map(function (child) {
        if (child.classList[0] == "active") {
          child.classList.remove('active')
        }
      });
      target.classList.add('active');
    }
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (

    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.mstr_student_teacher_first_name}&nbsp;{userLoginDetails.mstr_student_teacher_last_name}&nbsp;[&nbsp;{userLoginDetails.courseName}&nbsp;]</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Student Feedback on Course Transaction</div>
          </div>
          </div>
        </section>

        {componentLodignState == true ?
          <div class="loader-bg">
            <h3>Please Wait...</h3>
            <div class="loader">
              <span></span>
            </div>
          </div>
          :
          <>
            <section className='section section-elements'>
              <div className='feedbackFor'><a href='#' className='backToMain' onClick={clickBackToMain}><i className='fa fa-arrow-left'
                style={{ marginRight: '5px' }}></i>Back to Dashboard</a><span
                  className='divider'>|</span><strong>Year:</strong>{userLoginDetails.mstr_student_teacher_academic_year}<span className='divider'>|</span><strong>
                  Semester:</strong>{selectedStudentClassSemester} <span className='divider'>|</span> <strong>Program:</strong> {userLoginDetails.courseName}
                <span className='divider'>|</span> <strong>Section:</strong> {userLoginDetails.mstr_section_name}
                {/* 
            <span
              className='divider'>|</span>Section: <select className="form-control"
                style={{ display: 'inline-block', verticalAlign: 'middle', width: 'auto' }}>
              <option>--Select Section--</option>
              <option>A</option>
              <option>B</option>
              <option>C</option>
              <option>D</option>
            </select> */}
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='note note-thankyou'>
                    <span style={{ fontWeight: 'bold' }}>Note*: </span>Please note that you need to give feedback for all compulsory subjects. However we would really appreciate, if you give the feedback for optional subjects as well..</div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">

                  <div className='filterElements'>
                    <div className='selection'>
                    </div>
                    <div className='papers'>
                      <h4 className='heading'>Paper Type </h4>
                      <ol className='list-buttons list-papers'>
                        {
                          AllTheoryFeedbackSubmittedBit == true ?
                            <li pname='1' className={`${AllTheoryFeedbackSubmittedBit == true ? 'done' : ''}`}>Theory</li>
                            : <li pname='1' onClick={(event) => changePaperType("Theory", event)} className={`${TheroyPacticalActiveBit == true ? 'active' : ''} ${AllTheoryFeedbackSubmittedBit == true ? 'done' : ''}`}>Theory</li>
                        }

                        {/* {AllPracticalFeedbackSubmittedBit == true ?
                          <li pname='1' className={`${AllPracticalFeedbackSubmittedBit == true ? 'done' : ''}`}>Practical</li>
                          : <li pname='1' onClick={(event) => changePaperType("Practical", event)} className={`${TheroyPacticalActiveBit == false ? 'active' : ''} ${AllPracticalFeedbackSubmittedBit == true ? 'done' : ''}`}>Practical</li>
                        } */}
                      </ol>
                    </div>

                    <div className='papers'>
                      <h4 className='heading'>Paper Names </h4>
                      <ol className='list-buttons list-papers'>
                        {
                          Object.keys(allSubjectAndTeacherDetailsArray).length != 0 ?
                            Object.keys(allSubjectAndTeacherDetailsArray).map(function (key, index) {
                              return (
                                (Object.keys(allSubjectAndTeacherDetailsArray[key]).every((k) => allSubjectAndTeacherDetailsArray[key][k] == 0) != true && Object.keys(allSubjectAndTeacherDetailsArray[key]).every((k) => allSubjectAndTeacherDetailsArray[key][k] == 1) != true) ?
                                  activeSubject == 0 ?
                                    <li className='active' key={"TestSubjectAndTeacherDetails" + key.split('~')[1]} pname='1' customesubjectid={key.split('~')[1]} selected={activeSubject++, subjectProgramChange(key, "No", key.split('~')[1])} onClick={(event) => subjectProgramChange(key, "Yes", event)}>{key.split('~')[0]} ({key.split('~')[2]})</li>
                                    : <li className='' key={"TestSubjectAndTeacherDetails" + key.split('~')[1]} pname='1' customesubjectid={key.split('~')[1]} onClick={(event) => subjectProgramChange(key, "Yes", event)} >{key.split('~')[0]} ({key.split('~')[2]}) </li>
                                  : Object.keys(allSubjectAndTeacherDetailsArray[key]).every((k) => allSubjectAndTeacherDetailsArray[key][k] == 0) == true ?
                                    activeSubject == 0 ?
                                      <li className='active' key={"TestSubjectAndTeacherDetails" + key.split('~')[1]} pname='1' customesubjectid={key.split('~')[1]} selected={activeSubject++, subjectProgramChange(key, "No", key.split('~')[1])} onClick={(event) => subjectProgramChange(key, "Yes", event)}>{key.split('~')[0]} ({key.split('~')[2]}) </li>
                                      : <li className='' key={"TestSubjectAndTeacherDetails" + key.split('~')[1]} pname='1' customesubjectid={key.split('~')[1]} onClick={(event) => subjectProgramChange(key, "Yes", event)} >{key.split('~')[0]} ({key.split('~')[2]}) </li>
                                    : Object.keys(allSubjectAndTeacherDetailsArray[key]).every((k) => allSubjectAndTeacherDetailsArray[key][k] == 1) == true ?
                                      <li className='done' key={"TestSubjectAndTeacherDetails" + key.split('~')[1]} pname='1' customesubjectid={key.split('~')[1]}>{key.split('~')[0]} ({key.split('~')[2]}) </li>
                                      : null
                              )
                            })
                            : null
                        }
                      </ol>


                    </div>
                    <div className='teachers'>
                      <h4 className='heading'>Teacher Names </h4>
                      <ol className='list-buttons list-teachers list-teachers1'>
                        {
                          Object.keys(allTeacherNameWithIDArray).length != 0 ?
                            Object.keys(allTeacherNameWithIDArray).map(function (key, index) {
                              return (
                                (
                                  allTeacherNameWithIDArray[key] == 0 ?
                                    activeTeacher == 0 ?
                                      <li className='active' key={"TestTeacherName" + key.split('~')[1]} pname='1' custometeacherid={key.split('~')[1]} selected={activeTeacher++, teacherProgramChange(key, "No", key.split('~')[1])} onClick={(event) => teacherProgramChange(key, "Yes", event)}>{key.split('~')[0]} </li>
                                      : <li className='' key={"TestTeacherName" + key.split('~')[1]} pname='1' custometeacherid={key.split('~')[1]} onClick={(event) => teacherProgramChange(key, "Yes", event)} >{key.split('~')[0]} </li>

                                    : <li className='done' key={"TestTeacherName" + key.split('~')[1]} pname='1' custometeacherid={key.split('~')[1]}>{key.split('~')[0]} </li>
                                )
                              )
                            })
                            : null
                        }
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className='section-survey section-surveyStudentInfrastructure'>
              <div className="row">
                <div className="col-md-12">
                  <div className='info info-white'>Fields marked with <em>*</em> are mandatory</div>
                  <div className='questionnnaire-wrapper'>
                    <div className='grid-row row-header sticky'>
                      <div className='column col-srno'>#</div>
                      <div className='column col-question'><div className='column-content'> &nbsp;</div></div>
                      <div className='column col-grade'>Strongly Agree</div>
                      <div className='column col-grade'>Agree</div>
                      <div className='column col-grade'>Neutral</div>
                      <div className='column col-grade'>Disagree</div>
                      <div className='column col-grade'>Strongly Disagree</div>
                    </div>
                    {
                      allCourseTransactionQuestionsArray.length >= 1 ?
                        allCourseTransactionQuestionsArray.map((questions, index) => (
                          <CommonComponentForQuestionsAndOption key={"uniqueKey" + index + 1} term={questions} onItemClick={onItemClick} srNo={index + 1} />
                        ))
                        : null
                    }
                  </div>
                </div>

                {allCompalsoryDoneBit == false ?
                  <div className='col-md-12'>
                    <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={onCourseTransactionClick}>Save and go to next</button>
                  </div>
                  :
                  <>
                    <div className='col-md-12'>
                      <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={onCourseTransactionClick}>Save and go to next</button>
                    </div>
                    {/* <div className='col-md-6'>
                      <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={updateFinalCourseTransactionBit}>Skip & Submit</button>
                    </div> */}
                  </>
                }
              </div>
            </section>

          </>
        }

        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>

      </div>
      <ToastContainer />
      <Modal
        show={modelPopupStatus}
        backdrop="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body>
          <div className="font-robo">
            <div className="">
              <div className="card card-1 " style={{ boxShadow: 'none' }}>
                {/* <div className="logo-holder">
                  <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                  <div className='feedback-title' >Feedback System</div>
                </div> */}
                <div className="card-body card-thankyou" style={{ padding: '28px 28px', textAlign: 'center' }}>
                  <center>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                      <circle className="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                      <polyline className="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                    </svg>
                  </center>
                  <div className='message-submitThankyou'>
                    <h3>Student course transaction feedback submitted successfully.<br />Thank you for your valuable time.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <center>
            <button className='btn btn-primary btn-submitForm' style={{ display: 'block' }} onClick={saveAndClose}>
              Back to Main Page
            </button>
          </center>
        </Modal.Footer>
      </Modal>
    </div>


  )
}